<template>
  <v-container class="px-0">
    <v-expansion-panels v-model="panels" accordion>
      <v-expansion-panel>
        <v-expansion-panel-header
          class="font-weight-bold pl-4 text-decoration-underline"
          style="font-weight: 300; font-size: 15px"
        >
          Mapeamentos
        </v-expansion-panel-header>
        <v-expansion-panel-content class="validacoes-sdi-map-content">
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <tr>
                  <th class="subtitle-1">Nome do Arquivo</th>
                  <th class="subtitle-1">Colisões</th>
                  <th class="subtitle-1">Ações</th>
                </tr>
                <tr v-for="(value, key) in uploadedFiles" :key="key">
                  <td class="px-4" style="width: 55% !important">
                    <span class="d-inline-flex">
                      {{ value.nome }}
                      <v-icon size="9" class="mb-3 pl-1" color="error">mdi-asterisk</v-icon>
                    </span>
                  </td>
                  <td class="px-4" style="width: 45% !important">
                    <validation-provider v-slot="{ errors }" rules="required">
                      <v-select
                        v-model="parametros[value.id]"
                        item-text="nome"
                        item-value="value"
                        value="1"
                        dense
                        :items="colisoes"
                        :loading="loading"
                        :disabled="loading"
                        :hide-details="errors.length ? false : true"
                        :error-messages="errors"
                      />
                    </validation-provider>
                  </td>
                  <td class="px-4" style="width: 5% !important">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="primary"
                          min-width="0"
                          class="px-1"
                          fab
                          icon
                          x-small
                          v-bind="attrs"
                          v-on="on"
                          @click="
                            ($emit('mapeamento:apagar-arquivo', { id: value.id, nomeArquivo: value.nome, file: value.file }),
                            apagarParametroByArquivoId(value.id))
                          "
                        >
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </template>
                      <span>Clique aqui para excluir o arquivo {{ value.nome }}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>
<script>
  import importacoesSpedService from '../../services/importacoesSpedService';

  export default {
    props: {
      uploadedFiles: {
        type: Array,
        default: () => []
      },

      importacao: {
        type: Object,
        default: () => {}
      },

      idImportacao: {
        type: Number
      }
    },

    emits: ['mapeamento:apagar-arquivo'],

    data: () => ({
      panels: 0,
      search: '',
      loading: false,
      parametros: {},
      headers: [
        {
          text: 'Nome',
          value: 'nome'
        },
        {
          text: 'Colisões',
          value: 'colisoes'
        },
        {
          text: 'Ações',
          value: 'acoes'
        }
      ],
      colisoes: [
        {
          nome: 'ATUALIZAR',
          value: 1
        },
        {
          nome: 'IGNORAR',
          value: 0
        }
      ]
    }),

    mounted() {
      this.setValorParamentros('');
    },

    methods: {
      setValorParamentros(uploadedFiles) {
        if (uploadedFiles.length == 0) {
          this.uploadedFiles.forEach((file) => {
            this.parametros[file.id] = 1;
          });
          return;
        }

        let naoMapeados = this.uploadedFiles.filter((file) => {
          let arquivosMapeados = Object.keys(this.parametros).toString();
          if (arquivosMapeados.indexOf(file.id) == '-1') {
            return true;
          }
        });

        naoMapeados.forEach((arquivo) => {
          this.parametros[arquivo.id] = 1;
        });
      },

      setUpdates() {
        importacoesSpedService
          .setUpdates(this.parametros)
          .then(() => {
            this.$toast.success('Mapeamento da Importações de SPED salva com sucesso.', '', { position: 'topRight' });
          })
          .catch((err) => {
            this.$toast.error('Erro ao atualizar mapeamento da Importações de SPED.', '', { position: 'topRight' });
            console.error(err);
            return 'false';
          })
          .finally(() => this.changeStatusAguardando());

        return 'true';
      },

      changeStatusAguardando() {
        importacoesSpedService
          .changeStatusAguardando(this.importacao, this.idImportacao)
          .then(() => {
            this.$toast.success('Importações de SPED salva com sucesso.', '', { position: 'topRight' });
          })
          .catch((err) => {
            this.$toast.error('Erro ao salvar Importações de SPED.', '', { position: 'topRight' });
            console.error(err);
          })
          .finally(() => {
            this.$router.push('/importacoes-sped/');
          });
      },

      apagarParametroByArquivoId(id) {
        delete this.parametros[id];
      }
    },

    watch: {
      uploadedFiles(newValue) {
        this.setValorParamentros(newValue);
      }
    }
  };
</script>
<style>
  .validacoes-sdi-map-content .v-expansion-panel-content__wrap {
    padding: 0 !important;
  }
</style>